import Modal from '../../../../../components/templates/Modal/Modal';
import ReferenceEntry from '../../../../brand/features_public/reference_index/controllers/ReferenceEntry';

const AddReference = ({ onSuccess }) => {
  return <ReferenceEntry onCreateSuccess={onSuccess} isAdmin />;
};
export default Modal(AddReference, false);
